export default () => {
  const colorContainer = document.getElementById('picker_pa_kleur')
  if (!colorContainer) return

  const colors = colorContainer.querySelectorAll('.select-option')
  ;[...colors].forEach(color => {
    if (color.dataset.attribute && color.dataset.attribute === 'pa_kleur') {
      color.addEventListener('click', e => {
        updateURL(color.dataset.value)
      })
    }
  })

  const updateURL = color => {
    // Update URL so page is set on refresh
    if (history.pushState) {
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?attribute_pa_kleur=${color}`
      window.history.pushState({ path: newurl }, '', newurl)
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/UpdateColorURL.js